module.exports = __webpack_public_path__ + "img/e37dfbfe7d5f477b11bba1b2c803f78d.png";